module.exports = __webpack_public_path__ + "static/media/pin-light-privado.8f5df68c.png";